import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

function RefundPolicy() {
  const navigate = useNavigate();

  return (
    <div className="page" style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem 1rem' }}>
      <button onClick={() => navigate('/')} className="btn btn-ghost" style={{ marginBottom: '2rem' }}>
        <ArrowLeft size={20} style={{ marginRight: '0.5rem' }} /> Back to Home
      </button>

      <h1 style={{ fontSize: '2.5rem', marginBottom: '2rem' }}>Refund Policy</h1>
      
      <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#D1D5DB' }}>
        <p style={{ marginBottom: '1.5rem' }}><strong>Last Updated:</strong> January 2025</p>
        
        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>1. Service Nature</h2>
        <p style={{ marginBottom: '1rem' }}>Astrowins provides digital analysis and consultation services based on numerology, vastu, and astrology. Once an analysis is generated, the service is considered delivered.</p>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>2. Refund Eligibility</h2>
        <p style={{ marginBottom: '1rem' }}>Refunds may be considered in the following cases:</p>
        <ul style={{ marginBottom: '1.5rem', paddingLeft: '2rem' }}>
          <li>Technical errors preventing service delivery</li>
          <li>Duplicate charges</li>
          <li>Service not rendered due to our technical fault</li>
        </ul>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>3. Non-Refundable</h2>
        <ul style={{ marginBottom: '1.5rem', paddingLeft: '2rem' }}>
          <li>Completed analyses and reports</li>
          <li>Dissatisfaction with astrological predictions</li>
          <li>Change of mind after receiving results</li>
        </ul>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>4. Refund Process</h2>
        <p style={{ marginBottom: '1rem' }}>Please contact:</p>
        <div style={{ padding: '1.5rem', background: '#1E2139', borderRadius: '12px', marginBottom: '1rem' }}>
          <p style={{ marginBottom: '0.5rem' }}><strong>Mobile Number:</strong> <a href="tel:+919755313976" style={{ color: '#00D9FF' }}>+91 97553 13976</a></p>
          <p style={{ marginBottom: '0.5rem' }}><strong>Business Name:</strong> Greenfrog Interactive</p>
          <p><strong>Email ID:</strong> <a href="mailto:goalypmic101@gmail.com" style={{ color: '#00D9FF' }}>goalypmic101@gmail.com</a></p>
        </div>
        <p style={{ marginBottom: '1rem' }}>Apply for refund with valid reasons. After due diligence and approval, the refunded amount will be credited in 5-7 working days.</p>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>5. Subscription Cancellation</h2>
        <p style={{ marginBottom: '1rem' }}>Since this is a subscription-based service, you can stop your subscription immediately if not interested. Balance days will be calculated on a prorata basis. Refund will be processed automatically and credited to your account within 5-7 working days.</p>
      </div>
    </div>
  );
}

export default RefundPolicy;